module.exports = function (list) {
  var addAsync = function (values, callback, items) {
    var valuesToAdd = values.splice(0, 50)
    items = items || []
    items = items.concat(list.add(valuesToAdd))
    if (values.length > 0) {
      setTimeout(function () {
        addAsync(values, callback, items)
      }, 1)
    } else {
      list.update()
      callback(items)
    }
  }
  return addAsync
}



//////////////////
// WEBPACK FOOTER
// /var/www/nitrointeractive.dev/releases/20220802215704/web/app/themes/catalyst-2018/node_modules/list.js/src/add-async.js
// module id = 19
// module chunks = 0